var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdcInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.48223 3H15.5178C18.5455 3 21 5.45448 21 8.48223V15.5178C21 18.5455 18.5455 21 15.5178 21H8.48223C5.45448 21 3 18.5455 3 15.5178V8.48223C3 5.45448 5.45448 3 8.48223 3ZM19.6294 8.48223C19.6244 6.2135 17.7865 4.37558 15.5178 4.37056H8.48223C6.2135 4.37558 4.37558 6.2135 4.37056 8.48223V15.5178C4.37558 17.7865 6.2135 19.6244 8.48223 19.6294H15.5178C17.7865 19.6244 19.6244 17.7865 19.6294 15.5178V8.48223Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.07107 12C8.07609 9.83219 9.8322 8.07609 12 8.07107C14.1678 8.07609 15.9239 9.83219 15.9289 12C15.9289 14.1699 14.1699 15.9289 12 15.9289C9.83011 15.9289 8.07107 14.1699 8.07107 12ZM14.5584 12C14.5584 10.587 13.413 9.44162 12 9.44162C10.5891 9.44664 9.44664 10.5891 9.44162 12C9.44162 13.413 10.587 14.5584 12 14.5584C13.413 14.5584 14.5584 13.413 14.5584 12Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3442 7.11624C15.3442 6.56873 15.788 6.12487 16.3355 6.12487C16.8831 6.12487 17.3269 6.56873 17.3269 7.11624C17.3269 7.66376 16.8831 8.10761 16.3355 8.10761C15.788 8.10761 15.3442 7.66376 15.3442 7.11624Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdcInsta);
export default __webpack_public_path__ + "static/media/edc-insta.256db1a55c4ee5da9636b6369403e92e.svg";
export { ForwardRef as ReactComponent };